import React from 'react';
import { Select } from 'antd';

const LicenseTypeSelect: React.FC<SolvencyEstateTypeProps> = ({ value, onChange, placeholder, showCesante = false }) => {
  return (
    <Select value={value} onChange={onChange} placeholder={placeholder}>
      <Select.Option value='TEMPORAL'>Temporal</Select.Option>
      <Select.Option value='PERMANENTE'>Permanente</Select.Option>
      {showCesante && <Select.Option value='CESANTE'>Cesante</Select.Option>}
      {showCesante && <Select.Option value='INHABILITADA'>Inhabilitada</Select.Option>}
      {showCesante && <Select.Option value='SANCIONADO'>Sancionado</Select.Option>}
    </Select>
  );
};

export default LicenseTypeSelect;

interface SolvencyEstateTypeProps {
  value?: any
  onChange?: (e: any) => any
  placeholder?: string
  showCesante?: boolean
};